import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import { GET_KNOWLEDGECENTER_DOC, RM_KNOWLEDGECENTER_DOC, UPLOAD_KNOWLEDGECENTER_DOC } from "./constant"
import { getKnowledgeCenterDocAPI, rmKnowledgeCenterDocAPI, uploadKnowledgeCenterDocAPI } from "./api"
import { getKnowledgeCenterDocFail, getKnowledgeCenterDocSuccess, rmKnowledgeCenterFileFail, rmKnowledgeCenterFileSuccess, uploadKnowledgeCenterDocFail, uploadKnowledgeCenterDocSuccess } from "./action"



function* uploadKnowledgeCenterDoc(payload) {
    try {


        const response = yield call(uploadKnowledgeCenterDocAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(uploadKnowledgeCenterDocSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(uploadKnowledgeCenterDocFail(error.response.data.error || "Unable to Upload File"))
    }
}


function* getKnowledgeCenterDoc() {
    try {
        const response = yield call(getKnowledgeCenterDocAPI)
        if (response && response.data.status === 1) {
            yield put(getKnowledgeCenterDocSuccess(response.data.data))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(getKnowledgeCenterDocFail(error.response.data.error || "Unable to Upload File"))
    }
}

function* rmKnowledgeCenterDoc(payload) {
    try {
        const response = yield call(rmKnowledgeCenterDocAPI, payload.payload)
        if (response && response.data.status === 1) {
            yield put(rmKnowledgeCenterFileSuccess(response.data.message))
        } else {
            throw response;
        }

    } catch (error) {
        console.log("error", error)
        yield put(rmKnowledgeCenterFileFail(error.response.data.error || "Unable to Delete File"))
    }
}

function* KnowledgeCenterSaga() {

    yield takeEvery(UPLOAD_KNOWLEDGECENTER_DOC, uploadKnowledgeCenterDoc)
    yield takeEvery(GET_KNOWLEDGECENTER_DOC, getKnowledgeCenterDoc)
    yield takeEvery(RM_KNOWLEDGECENTER_DOC, rmKnowledgeCenterDoc)
    //yield takeLatest(LOGOUT_SU_USER, logoutUser)
}

export default KnowledgeCenterSaga;
